<template>
  <div class="wrapper">
    <riseup-header />
    <div class="content-loader">
      <lottie-player
        :src="cashflowLoader"
        autoplay
        loop
        class="animation"
      />
      <div class="content">
        <p class="text">
          The account was connected successfully
        </p>
        <h1>We’re preparing your insights!</h1>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import cashflowLoader from '../../assets/animations/cashflow-loader.json';
import RiseupHeader from '../Common/RiseupHeader.vue';
import Segment from '../../Segment';

Segment.trackUserGot('OtsCashflowLoaderEntered');

</script>
<style lang="scss" scoped>
  @import '../../scss/riseup-vars';

  .wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: $main_background_color;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
  }
  .content-loader {
    display: flex;
    flex: 1;
    width: 100%;
    margin: 0 auto;
    align-items: center; /* Center content vertically */
    padding-left: 40px; /* Add left padding */
  }

  .content h1 {
    // We’re preparing your insights!
    color: #205441;
    font-size: 28px;
    font-family: GrenetteSemiBold;
    font-weight: 600;
    line-height: 34px;
    word-wrap: break-word;

  }

  .content .text{
    // The account was connected successfully
    color: #205441;
    font-size: 16px;
    font-family: CircularStdBook;
    font-weight: 450;
    line-height: 18px;
    word-wrap: break-word;
    padding-bottom: 22px;
  }

  .animation {
    position: absolute;
    right: -20px;
  }

</style>
